module.exports = __webpack_public_path__ + "img/vmc_aniv17_24Aug2021.e7f598fc.jpg";